export interface DashboardTab {
  value: string;
  label: string;
}

export const DASHBOARD_TABS: DashboardTab[] = [
  { value: 'home', label: 'Home' },
  { value: 'rpm', label: 'RPM' },
  { value: 'ccm', label: 'CCM' },
];

export type DashboardTabValue = (typeof DASHBOARD_TABS)[number]['value'];

export const DEFAULT_TAB: DashboardTabValue = 'home';

export const isValidTab = (value: string): value is DashboardTabValue =>
  DASHBOARD_TABS.some((tab) => tab.value === value);
